"use client";

import type { CSSProperties } from "react";
import { useMemo, useState } from "react";

import { ToolFrame } from "@/components/tools/ToolFrame";

type Batch = { id: number; lot: string; expiry: string; qty: number };

export function FefoPickerHelperClient() {
  const [rows, setRows] = useState<Batch[]>([
    { id: 1, lot: "LOT-A", expiry: "", qty: 0 },
    { id: 2, lot: "LOT-B", expiry: "", qty: 0 },
  ]);

  const ranked = useMemo(
    () =>
      [...rows]
        .filter((r) => r.expiry)
        .sort((a, b) => new Date(a.expiry).getTime() - new Date(b.expiry).getTime())
        .map((r, i) => ({ ...r, priority: i + 1 })),
    [rows],
  );

  function update(id: number, patch: Partial<Batch>) {
    setRows((p) => p.map((r) => (r.id === id ? { ...r, ...patch } : r)));
  }

  return (
    <ToolFrame
      toolKey="fefo-picker-helper"
      title="FEFO Picker Helper"
      embedPath="/embed/fefo-picker-helper"
      exportCsvRows={ranked.map((r) => ({ priority: r.priority, lot: r.lot, expiry: r.expiry, qty: r.qty }))}
    >
      <div style={{ display: "grid", gap: ".6rem", maxWidth: "620px" }}>
        {rows.map((r) => (
          <div key={r.id} className="ed-card-glass" style={{ display: "grid", gap: ".45rem", gridTemplateColumns: "1fr 1fr 1fr", padding: ".8rem", borderRadius: "12px" }}>
            <input value={r.lot} onChange={(e) => update(r.id, { lot: e.target.value })} placeholder="Lot/batch" style={{ ...baseInput }} />
            <input type="date" value={r.expiry} onChange={(e) => update(r.id, { expiry: e.target.value })} style={{ ...baseInput }} />
            <input type="number" value={r.qty} onChange={(e) => update(r.id, { qty: Number(e.target.value || 0) })} placeholder="Qty" style={{ ...baseInput }} />
          </div>
        ))}
        <button type="button" className="ed-btn-secondary" onClick={() => setRows((p) => [...p, { id: Date.now(), lot: "", expiry: "", qty: 0 }])}>
          Add batch
        </button>
      </div>

      <div className="ed-card-glass" style={{ marginTop: "1rem", padding: "1rem", borderRadius: "12px" }}>
        <p style={{ margin: "0 0 .5rem", fontWeight: 700, color: "#0c4a6e" }}>Pick priority (earliest expiry first)</p>
        <ol style={{ margin: 0, paddingLeft: "1.1rem", lineHeight: 1.7 }}>
          {ranked.map((r) => (
            <li key={r.id}>
              {r.lot || "(unlabeled lot)"} · {r.expiry} · qty {r.qty}
            </li>
          ))}
        </ol>
      </div>
    </ToolFrame>
  );
}

const baseInput: CSSProperties = {
  width: "100%",
  padding: ".55rem .65rem",
  borderRadius: "8px",
  border: "1px solid rgba(148,163,184,.45)",
  boxSizing: "border-box",
};

